









































import { mapActions, mapState } from 'vuex';
import * as vr from '@/helpers/validation';
import { ConfirmationDialogData, OperatorBalance } from '@/api/schema';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import { errorToastMessage } from '@/helpers/errorToastMessage';

export default {
  name: 'OperatorSubscriptionsSettings',
  components: {
    ConfirmationDialog
  },
  data(): any {
    return {
      confirmationDialogState: false,
      confirmationDialogData: {
        header: 'Are you sure to update Subscription Fee?',
        okText: 'Save'
      } as ConfirmationDialogData,
      formData: {
        enableSubscriptionFee: 0
      } as any,
      isFormValid: false,
      rules: [
        (v: any) => vr.required(v),
        (v: any) => vr.validNumber(v)
      ]
    };
  },
  watch: {
    balance: {
      handler(newVal: OperatorBalance): void {
        this.formData = { ...this.formData, ...newVal };
        this.$refs.form?.resetValidation();
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState('OperatorPayments', ['loading', 'balance']),
    isValuesChanged(): boolean {
      return (
        this.formData?.enableSubscriptionFee !==
        this.balance?.enableSubscriptionFee
      );
    }
  },
  methods: {
    ...mapActions('OperatorPayments', ['saveOperatorBalance']),
    async handleOnFormSubmit(): Promise<void> {
      const form = this.$refs.form;

      await form.validate();

      if (!this.isFormValid) {
        return;
      }

      try {
        await this.saveOperatorBalance({
          ...this.balance,
          ...this.formData
        });

        this.$toast.success('Subscription Fee has been updated');
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.confirmationDialogState = false;
      }
    }
  }
};
